{
  "id": "campaign-113",
  "name": "Noble Promenade",
  "seed": "campaign:113",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....ACCCCCCCCA....",
    ".....C......C~~.x.",
    "*....C.t..t.C~x..*",
    "*B...C......C...B*",
    "*....C......C....*",
    "ww+ww+wwwwww+ww+ww",
    "ww+ww+wwwwww+ww+ww",
    "....,C,..,,.C~~~..",
    "..t.tC..ww..Ct~t..",
    ".....Ct.ww.tC.....",
    ".....C......C.....",
    ".....C%%..%%C.....",
    "..Y..C.%..%.C..Y..",
    ".....C......C.....",
    ".....C.t..t.C.....",
    ".....CCCCCCCC.....",
    "..................",
    "S...........x....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 12,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 16
    },
    {
      "kind": "rabbit",
      "x": 15,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 14,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 4
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 0
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 0,
      "y": 1,
      "w": 3,
      "h": 3
    },
    {
      "x": 15,
      "y": 1,
      "w": 3,
      "h": 3
    }
  ],
  "generatorVersion": 3,
  "level": 113,
  "biome": "estate",
  "par": {
    "reel": 8951,
    "push": 7771,
    "selfPropelled": 6702,
    "tractor": 5630,
    "zeroTurn": 4813,
    "fairway": 3478
  },
  "goldTime": {
    "reel": 8793,
    "push": 7666,
    "selfPropelled": 6606,
    "tractor": 5630,
    "zeroTurn": 4719,
    "fairway": 3443
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 14,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 1
    },
    "gold": {
      "reel": 45,
      "push": 37,
      "selfPropelled": 25,
      "tractor": 0,
      "zeroTurn": 25,
      "fairway": 45
    }
  }
}
